import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-aror-select',
  templateUrl: './aror-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ARReceiptSelectComponent),
      multi: true
    }
  ]
})
export class ARReceiptSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = ``;
    if (searchValue) {
      filter = this.odata.getSearchFilterString(searchValue, [
        'CustomerName',
        'DocCode'
      ]);
    }
    let url = `api/arreceipts/lookup?$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
